import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components/native';
import Colors from '../colors';
import Icon from '../icon';
import Text from '../text';
import Spacer from '../spacer';
const StyledPressable = styled.Pressable`
  justify-content: center;
`;
const StyledIconDiv = styled.View`
  position: absolute;
  top: 2;
  right: 2;
`;
const Types = ['default', 'selected'];
const color = {
  default: {
    text: Colors.gray600,
    icon: Colors.advanceBlue400
  },
  selected: {
    text: Colors.mint600,
    icon: Colors.mint400
  }
};
export default function SquareBtn(props) {
  const type = Types.includes(props.type) ? props.type : SquareBtn.defaultProps.type;
  const StyledIcon = props.iconFamily;
  return /*#__PURE__*/React.createElement(StyledPressable, {
    style: [styles.button, styles[type]],
    onPress: props.onPress
  }, /*#__PURE__*/React.createElement(StyledIcon, {
    color: color[type].icon,
    name: props.icon,
    size: 24.75,
    style: styles.icon
  }), /*#__PURE__*/React.createElement(Spacer, {
    size: "f8",
    height: true
  }), /*#__PURE__*/React.createElement(Text.BodyExtraSmall, {
    color: color[type].text,
    style: styles.text
  }, props.children), type === 'selected' && /*#__PURE__*/React.createElement(StyledIconDiv, null, /*#__PURE__*/React.createElement(Icon.MaterialIcons, {
    color: color[type].icon,
    name: "check-circle",
    size: 16
  })));
}
SquareBtn.propTypes = {
  type: PropTypes.string,
  icon: PropTypes.string,
  iconFamily: PropTypes.elementType,
  onPress: PropTypes.func,
  children: PropTypes.string
};
SquareBtn.defaultProps = {
  type: 'default',
  icon: '',
  iconFamily: Icon.MaterialIcons,
  onPress: () => {},
  children: ''
};
const styles = {
  button: {
    borderRadius: 4,
    overflow: 'hidden',
    borderWidth: 2,
    alignItems: 'center',
    justifyContent: 'flex-start',
    width: 72,
    height: 72
  },
  default: {
    backgroundColor: Colors.lightGray200,
    borderColor: Colors.lightGray200,
    boxShadow: '0px 1px 1px rgba(0, 0, 0, 0.025), 0px 2px 4px rgba(0, 0, 0, 0.1)'
  },
  selected: {
    backgroundColor: Colors.white,
    borderColor: Colors.mint400
  },
  icon: {
    height: 24,
    marginTop: 10
  },
  text: {
    textAlign: 'center'
  }
};
//# sourceMappingURL=square.js.map